import styled, { css } from 'styled-components'
import Box from 'components/shared/Box'
import { Color } from 'styles/types'
import { fadeInOnRender } from 'styles/animations'

interface WrapperProps {
    background:
        | 'error_bg'
        | 'success_bg'
        | 'info_bg'
        | 'warning_bg'
        | 'info_warning_bg'
        | Color
    hasSmallFont?: boolean
    hasNoPadding?: boolean
    hasBorder?: boolean
    hasNoBackground?: boolean
    hasNoShadow?: boolean
    borderColor?: Color
}

export const Wrapper = styled(Box)<WrapperProps>`
    background-color: ${({ theme, background, hasNoBackground }) =>
        hasNoBackground ? 'transparent' : theme.colors[background]};

    ${({ hasSmallFont, hasNoPadding, hasBorder }) =>
        !hasNoPadding &&
        css`
            padding: ${() =>
                hasSmallFont ? '8px 16px' : `${hasBorder ? '14px' : '16px'}`};
        `}
    ${({ hasNoShadow }) =>
        !hasNoShadow &&
        css`
            box-shadow: '0 -12px 35px rgba(138, 150, 198, 0.05)';
        `}
    border-radius: ${({ hasSmallFont }) => (hasSmallFont ? '4px' : '8px')};
    border: ${({ hasBorder }) => (hasBorder ? '2px solid' : 'none')};
    border-color: ${({ theme, borderColor }) =>
        borderColor ? theme.colors[borderColor] : theme.colors.grayscale_300};

    ${fadeInOnRender}
`
